/**
 * Created by kz on 28.06.17.
 */
import _ from 'lodash'

export const all = (state) => {
  return state.tenders
}

export const current = (state) => {
  return state.current
}

export const stage = (state, getters, rootState) => {
  return _.find(state.current.stages, {id: rootState.route.params.stageId}) || _.first(state.current.stages)
}

export const stageParticipations = (state) => {
  return state.stageParticipations
}

export const stageParticipationsAsCompanies = (state) => {
  return state.stageParticipations.map((p) => _.assign(p.participant, {enabled: p.enabled, participationId: p._id}))
}



// WEBPACK FOOTER //
// ./src/store/modules/tender/getters.js